import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Paper, Typography, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    MoneyTransfer as DMT_TRANSFER,
    GenerateOTPForSplitAmountForEzyPay as GENERATEOTPFORSPLITAMOUNT
} from 'Components/Api/EzyPayV1DMTAPI';
import { MONEY_TRANSFER_CODE } from 'Components/Helper/Messages';
import ReactTable from 'Components/ReactTable/ReactTable';
import { LOGOUT } from 'ConstComponents';
import CountdownTimer from 'Components/Timer/CountdownTimer';
import { SelectDMTForReceiptForWeb as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';
import { DMTTransactionPrint } from 'Components/Print/DMTPrint';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { OTPModal } from 'Components/Modal/OTPModal';
import { useHistory } from 'react-router';

const CustomContainer = HOCLoader(Container);

var otpTokenGlobal = '';
var extractedAmounts = [];
export const SplitAmount = ({ ActiveDMTName }) => {
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');

    const { MainRequest, OTPListRequest, DMTName } = location.state || {};
    const [otpList, setOTPList] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [serviceCode, setserviceCode] = useState(MONEY_TRANSFER_CODE);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isOTPButtonDisabled, setIsOTPButtonDisabled] = useState(false);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [mainRequet, setmainRequet] = useState('');
    const [originalamount, setoriginalamount] = useState('');
    const [openOTP, setOpenOTP] = useState(false);
    const [otpToken, setOtpToken] = useState('');
    const [printData, setPrintData] = useState(null);
    const [isPrint, setIsPrint] = useState(false);
    const [currentTransactionIndex, setCurrentTransactionIndex] = useState(
        null
    );
    const [amounts, setAmounts] = useState([]);
    const Pipe = location?.state?.Pipe;
    const {
        AccountNo,
        Amount,
        BankName,
        BeneMobile,
        BeneficiaryID,
        BeniName,
        IFSC,
        Mobile,
        Name,
        PaymentType,
        RechargePin,
        Remark,
        SenderID,
        SenderName
    } = MainRequest;
    const [mainColumns, setMainColumns] = useState([]);

    useEffect(() => {
        createColumns();
        setOTPList(OTPListRequest);
    }, [Mobile]);

    useEffect(() => {
        setOTPList(OTPListRequest);
        extractedAmounts = OTPListRequest.map((item) => item.Amount);
        setAmounts(extractedAmounts);
    }, [OTPListRequest, Mobile]);

    const SelectPrintData = async (TransactionMasterID) => {
        setIsError(false);
        var req = {
            ID: TransactionMasterID
        };

        if (!TransactionMasterID || TransactionMasterID <= 0) {
            setSeverity('error');
            setResponseMessage('Transaction not processed yet');
            setIsError(true);
            return;
        }

        var request = JSON.stringify(req);
        setLoading(true);
        const resp = await TRANSACTION_RECEIPT(request);
        setLoading(false);
        if (!resp.isAuthorized) LOGOUT();

        if (!resp.status) return;

        var data = JSON.parse(resp.data);
        data.Charge = 0;
        setPrintData(data);
        setIsPrint(true);
    };

    const GenerateOTPForSplitAmount = async (value) => {
        setCurrentTransactionIndex(value);
        const amount = extractedAmounts[value];

        let jsonObj = {
            Mobile: Mobile,
            BeneMobile: BeneMobile,
            Name: BeniName,
            BeniName: BeniName,
            SenderName: SenderName,
            BankName: BankName,
            AccountNo: AccountNo,
            IFSC: IFSC,
            BeneficiaryID: BeneficiaryID,
            SenderID: SenderID,
            PaymentType: PaymentType,
            RechargePin: RechargePin,
            Remark: Remark,
            DMTName: DMTName,
            //BillNumber: value.BillNumber,
            OriginalAmount: amount,
            Pipe: Pipe
        };
        setIsError(false);
        setLoading(true);
        setoriginalamount(jsonObj.OriginalAmount);
        var apirequest = JSON.stringify(jsonObj);
        var response = await GENERATEOTPFORSPLITAMOUNT(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data[0].Message);
            setIsError(true);
            return;
        }
        var result = JSON.parse(response.data);
        setSeverity('success');
        setResponseMessage(result.list[0].Message);
        setIsError(true);
        setOtpToken(result.list[0].OTPRefid);
        otpTokenGlobal = result.list[0].OTPRefid;
        setOpenOTP(true);
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'SRno'
            //srno: true
        });

        columns.push({
            label: <b>Amount</b>,
            name: 'Amount'
        });
        columns.push({
            label: (
                <h6>
                    <b>GET OTP</b>
                </h6>
            ),
            name: 'SRno',
            button: true,
            disabledOn: ['FAILURE', 'SUCCESS'],
            statusIndex: 3,
            callback: (value) => {
                GenerateOTPForSplitAmount(value);
            }
        });

        columns.push({
            label: <b>Status</b>,
            name: 'Status'
        });
        columns.push({
            label: <b>RRN</b>,
            name: 'RRN'
        });

        columns.push({
            label: (
                <h6>
                    <b>Receipt</b>
                </h6>
            ),
            name: 'VendorID',
            buttonTitle: 'Receipt',
            button: true,
            callback: (value) => {
                SelectPrintData(value);
            }
        });

        setMainColumns(columns);
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);

        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        setResponseMessage(data.Message);
        setIsError(true);
    };

    const updateOTPStatus = (
        srno,
        otpToken,
        status,
        message,
        vendorID,
        rrnNumber
    ) => {
        setOTPList((prevList) =>
            prevList.map((item) =>
                item.SRno === srno
                    ? {
                          ...item,
                          Status: status,
                          Message: message,
                          VendorID: vendorID,
                          RRN: rrnNumber
                      }
                    : item
            )
        );
    };

    const TransferWithOTP = async (values) => {
        setOpenOTP(false);
        let jsonObj = {
            Mobile: Mobile,
            BeneMobile: BeneMobile,
            Name: Name,
            SenderName: SenderName,
            BankName: BankName,
            AccountNo: AccountNo,
            IFSC: IFSC,
            BeneficiaryID: BeneficiaryID,
            SenderID: SenderID,
            PaymentType: PaymentType,
            RechargePin: RechargePin,
            Remark: Remark,
            DMTName: DMTName,
            Pipe: Pipe,
            BillNumber: values[3],
            OriginalAmount: originalamount,
            OTPToken: otpTokenGlobal,
            Amount: originalamount,
            OTP: values.OTP
        };
        setmainRequet(jsonObj);
        setIsError(false);
        setLoading(true);
        var apirequest = JSON.stringify(jsonObj);
        var response = await DMT_TRANSFER(apirequest);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);
            setIsError(true);
            return;
        }
        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setResponseMessage(dataError.Message);
            setSeverity('error');
            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);
        const otpToken = otpTokenGlobal;
        const status = data.Status;
        const message = data.Message;
        const vendorID = data.VendorID;
        const rrnNumber = data.TransactionID;

        updateOTPStatus(
            currentTransactionIndex,
            otpToken,
            status,
            message,
            vendorID,
            rrnNumber
        );
        if (data.Status === 'FAILURE') {
            setIsOTPButtonDisabled(true);
        }
        setResponseAlert(data);
        setIsResponseAlertOpen(true);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid container spacing={2} style={{ marginBottom: '12px' }}>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 'bold', marginBottom: '1rem' }}
                        >
                            Sender
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={4}>
                                <Typography
                                    variant="body1"
                                    style={{ marginBottom: '0.5rem' }}
                                >
                                    Mobile : {Mobile}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <CountdownTimer initialTime={120} />
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<ArrowBackIcon />}
                                    onClick={() => {
                                        history.push('/EZPV1SenderSearch', {
                                            Mobile: MainRequest.Mobile,
                                            Pipe: Pipe
                                        });
                                    }}
                                >
                                    Back To Beneficiary List
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 'bold', marginBottom: '1rem' }}
                        >
                            Beneficiary
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <Typography
                                    variant="body1"
                                    style={{ marginBottom: '0.5rem' }}
                                >
                                    Amount : {Amount}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography
                                    variant="body1"
                                    style={{ marginBottom: '0.5rem' }}
                                >
                                    Name : {BeniName}
                                </Typography>
                            </Grid>

                            <Grid item xs={3}>
                                <Typography
                                    variant="body1"
                                    style={{ marginBottom: '0.5rem' }}
                                >
                                    Account No : {AccountNo}
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography
                                    variant="body1"
                                    style={{ marginBottom: '0.5rem' }}
                                >
                                    IFSC : {IFSC}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            {isPrint && (
                <DMTTransactionPrint
                    isOpen={isPrint}
                    title="Transaction Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrint(false);
                    }}
                    negativeButtonClick={() => {
                        setIsPrint(false);
                    }}
                />
            )}
            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(values) => {
                        sendCallback(ResponseAlert);
                    }}
                />
            ) : null}

            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    request={{
                        mainRequet
                    }}
                    error={modalErrorMessage}
                    submitCallback={(e) => {
                        TransferWithOTP(e);
                        setOpenOTP(false);
                    }}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}
            <ReactTable
                data={otpList}
                columns={mainColumns}
                headerToolbar={false}
            />
        </CustomContainer>
    );
};
